class Decision {
  accepted?: boolean;
  db_change_id?: number;
  field?: string;
  value?: string;
}

export default Decision;
